import { GIPIBaseAbstractFilterModel } from '@gipi-shared/models/base-abstract-filter.model';
import { GIPIUuid } from '@gipisistemas/ng-core';

export class RegistrationProductFilterDTO extends GIPIBaseAbstractFilterModel {

    description: string;

    enabled: boolean;

    productsIdsExcluded: GIPIUuid[];

}
